import Iframe from "react-iframe";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "./WebPageMock.css";

function WebPageMock(props){
    const { t } = useTranslation();
    const fadeDuration = props.fadeIn != null
        ? (typeof props.fadeIn === "number" ? props.fadeIn : 0.35)
        : null;
    const useFade = fadeDuration != null;
    const urlKey = String(props.url || "");
    const [fadeInReady, setFadeInReady] = useState(!useFade);
    const previousUrlKey = useRef(null);

    useEffect(() => {
        if (!useFade) {
            return undefined;
        }
        if (previousUrlKey.current !== null && previousUrlKey.current !== urlKey) {
            setFadeInReady(false);
        }
        previousUrlKey.current = urlKey;

        const fallbackId = window.setTimeout(() => setFadeInReady(true), 3000);
        return () => window.clearTimeout(fallbackId);
    }, [urlKey, useFade]);

    function handleLoad() {
        if (useFade) {
            setFadeInReady(true);
        }
        if (props.onLoad) {
            props.onLoad();
        }
    }

    if (props.open){

        if (props.imageOverWebsite)
            return (
                <div style={{position: "absolute", width: props.frameWidth ? props.frameWidth : props.width, height: props.frameHeight ? props.frameHeight : props.height}} onClick={props.close}>
                    <img alt={t('AppPreviewAlt')} src={props.url}
                        width={props.frameWidth ? props.frameWidth : props.width}
                        height={props.frameHeight ? props.frameHeight : props.height}
                        style={{position: 'absolute', zIndex: 20, borderRadius: props.frameWidth && props.frameHeight ? 8 : 0, ...props.imgStyle}}/>
                </div>);
        else {
            const scale = props.scale != null && props.scale > 0 ? props.scale : 1;
            const iframeWidth = Math.round(props.width / scale);
            const iframeHeight = Math.round(props.height / scale);
            const iframeStyle = props.iframeStyle || {};
            const frameBorderRadius = props.frameBorderRadius ?? iframeStyle.borderRadius ?? 0;
            const { borderRadius: _ignoredRadius, ...iframeStylesWithoutRadius } = iframeStyle;
            const frameClassName = !useFade
                ? undefined
                : fadeInReady
                    ? "web-page-mock-frame web-page-mock-frame--fade-in"
                    : "web-page-mock-frame";
            return (
                <div
                    className={frameClassName}
                    style={{
                        position: "absolute",
                        width: props.width,
                        height: props.height,
                        overflow: "hidden",
                        borderRadius: frameBorderRadius,
                        backgroundColor: props.backgroundColor || "#FFFFFF",
                        zIndex: 20,
                        "--web-page-mock-fade-duration": useFade ? `${fadeDuration}s` : undefined,
                    }}
                >
                    <Iframe id={props.id} url={props.url} title={props.title || t('AppPreviewAlt')}
                        width={iframeWidth}
                        height={iframeHeight}
                        frameBorder={0}
                        display="block"
                        onLoad={handleLoad}
                        styles={{
                            position: 'absolute',
                            zIndex: 20,
                            border: 'none',
                            transform: scale !== 1 ? `scale(${scale})` : undefined,
                            transformOrigin: 'top left',
                            ...iframeStylesWithoutRadius,
                        }}/>
                </div>);
        }
    }
    else return null;
}

export default WebPageMock;
